import { render } from "./RTMVitalFormModal.vue?vue&type=template&id=4d2653ad&scoped=true"
import script from "./RTMVitalFormModal.vue?vue&type=script&lang=js"
export * from "./RTMVitalFormModal.vue?vue&type=script&lang=js"

import "./RTMVitalFormModal.vue?vue&type=style&index=0&id=4d2653ad&scoped=true&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2653ad"]])

export default __exports__